import { useAppStore } from "../store/appStore";

export const useAppData = () => useAppStore((store) => store.appData);
